var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, } from "react";
import { navigate } from "@reach/router";
import { InputGroup, InputLabel, InputText, InputSelect, useLoaderButton, useNotificationsCtx, TNotificationType, InputCSV, } from "@gw/component-library";
import { useBNIdentity, NSBNAuth } from "@gw/bn-identity";
import { useUserCreateFormFields } from "./useUserCreateFormFields";
var UserCreateForm = function (_a) {
    var userId = _a.userId;
    var _b = useState(NSBNAuth.BNRole.User), bnRole = _b[0], setBNRole = _b[1];
    var _c = useUserCreateFormFields(), fieldList = _c.fieldList, processWuFooCSV = _c.processWuFooCSV, values = _c.values;
    var roleOpts = [
        { label: NSBNAuth.BNRole.User, value: NSBNAuth.BNRole.User },
        { label: NSBNAuth.BNRole.Admin, value: NSBNAuth.BNRole.Admin },
    ];
    var _d = useLoaderButton({}), LoaderButton = _d.LoaderButton, enableButton = _d.enableButton, disableButton = _d.disableButton, setLoadingButton = _d.setLoadingButton;
    var _e = useBNIdentity(), createUser = _e.createUser, listUser = _e.listUser, updateUser = _e.updateUser;
    var addNotification = useNotificationsCtx().addNotification;
    useEffect(function () {
        if (userId) {
            listUser(userId)
                .then(function (user) {
                setBNRole(user.bn_role);
                fieldList.map(function (field) {
                    var userHasPayloadKey = Object.prototype.hasOwnProperty.call(user, field.payloadKey);
                    if (userHasPayloadKey) {
                        field.setter(user[field.payloadKey]);
                    }
                });
            })
                .catch(function () {
                addNotification("Could not find this User!", TNotificationType.error);
            });
        }
    }, [userId]);
    useEffect(function () {
        if ([
            values.email.trim(),
            values.first_name.trim(),
            values.last_name.trim(),
        ].includes("")) {
            disableButton();
        }
        else {
            enableButton();
        }
    }, [
        values.email,
        values.first_name,
        values.last_name,
        disableButton,
        enableButton,
    ]);
    var onChangeCb = function (ev, setter) {
        var val = ev.target.value;
        setter(val);
    };
    var onSubmitCb = function () {
        setLoadingButton();
        if (userId) {
            updateUser(__assign(__assign({}, values), { bn_role: bnRole }), userId)
                .then(function () {
                addNotification("User Updated! Redirecting in 5 seconds...", TNotificationType.success);
                window.setTimeout(function () {
                    navigate("/admin/users");
                }, 5000);
            })
                .catch(function (err) {
                addNotification("User Update Failed!", TNotificationType.error);
            });
        }
        else {
            createUser(__assign(__assign({}, values), { confirmed: false, bn_role: bnRole, last_logged_in: null }))
                .then(function () {
                addNotification("User Created! Redirecting in 5 seconds...", TNotificationType.success);
                window.setTimeout(function () {
                    navigate("/admin/users");
                }, 5000);
            })
                .catch(function () {
                addNotification("User Creation Failed!", TNotificationType.error);
            });
        }
    };
    return (React.createElement("form", { className: "user-create-form" },
        React.createElement(InputGroup, null,
            React.createElement(InputLabel, { htmlFor: "role" }, "Role"),
            React.createElement(InputSelect, { options: roleOpts, value: roleOpts.filter(function (o) { return o.value === bnRole; }), onChange: function (opt) {
                    setBNRole(opt.value);
                } })),
        React.createElement("hr", null),
        React.createElement(InputGroup, null,
            React.createElement("div", null, "You can selected a CSV file from the WuFoo output and upload it here, and all the fields below will be filled... magically!"),
            React.createElement(InputCSV, { onCSVRead: function (filename, fileData) {
                    processWuFooCSV(fileData);
                } })),
        fieldList.map(function (field) {
            return (React.createElement(InputGroup, { key: "field-" + field.name },
                React.createElement(InputLabel, { htmlFor: field.name },
                    field.label,
                    ":"),
                React.createElement(InputText, { value: field.value, name: field.name, type: "text", onChange: function (ev) {
                        onChangeCb(ev, field.setter);
                    } })));
        }),
        React.createElement("div", { className: "actions" },
            React.createElement(LoaderButton, { onClick: function (ev) {
                    onSubmitCb();
                } }, userId ? React.createElement(React.Fragment, null, "Update User") : React.createElement(React.Fragment, null, "Create User")))));
};
export default UserCreateForm;
//# sourceMappingURL=UserCreateForm.js.map